const marketplaceSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="204"
    height="22"
    viewBox="0 0 204 22"
    fill="none"
  >
    <path
      d="M18.7878 13.5527C18.6914 10.9415 18.5951 7.78228 18.5951 4.62305H18.5309C17.8243 7.39544 16.9251 10.4902 16.09 13.0369L13.4565 21.5153H9.63476L7.32242 13.1336C6.61587 10.5547 5.90932 7.45991 5.36335 4.62305H5.29912C5.20277 7.55662 5.07431 10.9093 4.94584 13.6172L4.52834 21.8699H0L1.38098 0.14209H7.9005L10.0202 7.39544C10.7267 9.90993 11.369 12.6178 11.8508 15.1646H11.9792C12.5573 12.6501 13.296 9.78098 14.0346 7.3632L16.3149 0.14209H22.738L23.8942 21.8699H19.1411L18.7878 13.5527Z"
      fill="#F8FFF9"
    />
    <path
      d="M32.5976 16.2929L31.056 21.8699H26.0139L32.5976 0.14209H39.0208L45.7651 21.8699H40.466L38.796 16.2929H32.5976ZM38.0894 12.6179L36.7406 8.00794C36.3552 6.71846 35.9698 5.1066 35.6486 3.81712H35.5844C35.2632 5.1066 34.9421 6.7507 34.5888 8.00794L33.3042 12.6179H38.0894Z"
      fill="#F8FFF9"
    />
    <path
      d="M48.6235 0.432277C50.1972 0.17438 52.5095 -0.019043 55.143 -0.019043C58.3546 -0.019043 60.6027 0.464514 62.1443 1.68952C63.461 2.72111 64.1676 4.26849 64.1676 6.26719C64.1676 9.00735 62.2085 10.9093 60.3458 11.5863V11.683C61.8552 12.2955 62.6902 13.714 63.2362 15.7127C63.9106 18.1949 64.5529 21.0318 64.9705 21.87H59.9604C59.6392 21.2252 59.0933 19.4844 58.4831 16.8087C57.8728 14.0686 56.9415 13.3594 54.9182 13.3271H53.473V21.87H48.6235V0.432277ZM53.473 9.78104H55.3999C57.8407 9.78104 59.2859 8.55603 59.2859 6.65404C59.2859 4.68758 57.9371 3.65599 55.689 3.65599C54.5007 3.65599 53.8262 3.72046 53.473 3.81717V9.78104Z"
      fill="#F8FFF9"
    />
    <path
      d="M67.6681 0.14209H72.5176V9.74875H72.5818C73.0636 8.91058 73.5774 8.13689 74.0913 7.3632L78.9729 0.14209H85.0107L77.8488 9.39414L85.3639 21.8699H79.6794L74.3482 12.4889L72.5176 14.7777V21.8699H67.6681V0.14209Z"
      fill="#F8FFF9"
    />
    <path
      d="M100.266 12.6823H92.301V17.8403H101.197V21.8699H87.4194V0.14209H100.747V4.17173H92.301V8.68492H100.266V12.6823Z"
      fill="#F8FFF9"
    />
    <path
      d="M108.905 4.26844H103.06V0.14209H119.696V4.26844H113.787V21.8699H108.905V4.26844Z"
      fill="#F8FFF9"
    />
    <path
      d="M122.618 0.400039C123.967 0.17438 125.734 -0.019043 127.982 -0.019043C130.744 -0.019043 132.767 0.625699 134.052 1.78624C135.208 2.81782 135.946 4.39744 135.946 6.33167C135.946 8.29813 135.368 9.84551 134.276 10.9738C132.767 12.5534 130.39 13.3594 127.661 13.3594C126.826 13.3594 126.055 13.3271 125.412 13.1659V21.87H122.618V0.400039ZM125.412 10.8771C126.023 11.0383 126.793 11.1028 127.725 11.1028C131.097 11.1028 133.152 9.42643 133.152 6.49285C133.152 3.59151 131.097 2.20532 128.046 2.20532C126.826 2.20532 125.894 2.30203 125.412 2.43098V10.8771Z"
      fill="#F8FFF9"
    />
    <path
      d="M139.029 0.14209H141.856V19.5166H151.105V21.8699H139.029V0.14209Z"
      fill="#F8FFF9"
    />
    <path
      d="M158.331 15.0356L156.083 21.8699H153.193L160.579 0.14209H163.919L171.306 21.8699H168.319L166.007 15.0356H158.331ZM165.461 12.8435L163.309 6.58951C162.827 5.17108 162.506 3.88159 162.185 2.62435H162.121C161.8 3.88159 161.479 5.23555 161.029 6.55727L158.909 12.8435H165.461Z"
      fill="#F8FFF9"
    />
    <path
      d="M188.777 21.193C187.781 21.7088 185.694 22.2246 183.06 22.2246C176.958 22.2246 172.398 18.3562 172.398 11.1995C172.398 4.36527 176.991 -0.212402 183.703 -0.212402C186.368 -0.212402 188.103 0.367866 188.841 0.754711L188.135 3.04355C187.107 2.52775 185.598 2.14091 183.799 2.14091C178.725 2.14091 175.353 5.39685 175.353 11.1028C175.353 16.4542 178.404 19.8391 183.639 19.8391C185.373 19.8391 187.107 19.4845 188.231 18.9364L188.777 21.193Z"
      fill="#F8FFF9"
    />
    <path
      d="M203.486 11.683H195.104V19.5166H204.482V21.8699H192.278V0.14209H204V2.4954H195.104V9.3619H203.486V11.683Z"
      fill="#F8FFF9"
    />
  </svg>
);

const chemsecSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="77"
    height="17"
    viewBox="0 0 77 17"
    fill="none"
  >
    <g clipPath="url(#clip0_2065_3)">
      <path
        d="M22.5699 8.71949L22.3689 8.52736C21.8545 8.03519 21.2838 7.79569 20.6247 7.79569C19.336 7.79569 18.4037 8.76949 18.4037 10.1091C18.4037 11.4488 19.3387 12.4331 20.6247 12.4331C21.2651 12.4331 21.892 12.1699 22.393 11.6935L22.5993 11.4961L23.6576 12.6384L23.4915 12.8226C22.8003 13.5885 21.7929 14.0096 20.6542 14.0096C18.3661 14.0096 16.7077 12.3699 16.7077 10.1091C16.7077 7.84833 18.3688 6.21655 20.6542 6.21655C21.8009 6.21655 22.8083 6.64029 23.4915 7.40617L23.6576 7.59303"
        fill="#F8FFF9"
      />
      <path
        d="M28.3651 6.2192C27.8533 6.2192 26.9906 6.32184 26.2699 6.90612V2.73193H24.59V13.8701H26.2699V9.66961C26.2699 8.57474 27.0469 7.81149 28.1614 7.81149C29.276 7.81149 29.9271 8.46157 29.9271 9.64066V13.8701H31.6016V9.28009C31.6016 7.44829 30.2995 6.2192 28.3651 6.2192Z"
        fill="#F8FFF9"
      />
      <path
        d="M36.3706 14.0123C34.0959 14.0123 32.5071 12.4121 32.5071 10.1197C32.5071 7.82733 34.104 6.21924 36.3063 6.21924C38.3827 6.21924 39.8991 7.84575 39.9152 10.0881C39.9152 10.246 39.9072 10.404 39.8911 10.5329L39.8616 10.7751H34.2567C34.4844 11.8462 35.2989 12.4989 36.4403 12.4989C37.2012 12.4989 37.9138 12.22 38.4979 11.6962L38.7203 11.4962L39.6607 12.6727L39.4785 12.8437C38.6345 13.6386 37.6486 14.0097 36.3733 14.0097L36.3706 14.0123ZM34.2835 9.33804H38.1737C37.9594 8.34844 37.2547 7.74574 36.2822 7.74574C35.3096 7.74574 34.5353 8.33528 34.2835 9.33804Z"
        fill="#F8FFF9"
      />
      <path
        d="M40.9011 6.35873H42.5676V6.91406C43.283 6.32188 44.1564 6.21924 44.6762 6.21924C45.8256 6.21924 46.7686 6.65613 47.3393 7.43254C47.9261 6.65613 48.8718 6.21924 50.0078 6.21924C51.9476 6.21924 53.2524 7.45097 53.2524 9.28013V13.8702H51.5779V9.6407C51.5779 8.46161 50.9482 7.81154 49.8042 7.81154C48.6602 7.81154 47.9127 8.57479 47.9127 9.66966V13.8702H46.2408V9.6407C46.2408 8.46161 45.6139 7.81154 44.4752 7.81154C43.3365 7.81154 42.581 8.57479 42.581 9.66966V13.8702H40.9011"
        fill="#F8FFF9"
      />
      <path
        d="M54.351 12.9859C55.1092 13.5176 56.3711 13.8703 57.5151 13.8703C58.978 13.8703 60.6873 13.2807 60.6873 11.6147C60.6873 10.2382 59.3531 9.80397 58.2305 9.68291L57.5151 9.60395C56.1916 9.45919 55.6022 9.09336 55.6022 8.41959C55.6102 7.64845 56.3979 7.15102 57.6116 7.15102C58.7369 7.15102 59.5969 7.55633 60.039 7.82215L60.4971 7.07206C59.6317 6.55095 58.686 6.29565 57.6116 6.29565C55.8058 6.29565 54.5921 7.18787 54.5921 8.51434C54.5921 9.91978 55.8969 10.3514 56.99 10.4672L57.7214 10.5462C58.5627 10.6357 59.6799 10.8541 59.6799 11.7174C59.6799 12.5227 58.8521 13.0228 57.5178 13.0228C56.497 13.0228 55.4628 12.6306 54.86 12.2306L54.351 12.9859Z"
        fill="#F8FFF9"
      />
      <path
        d="M65.0277 6.28491C62.8923 6.28491 61.3411 7.88247 61.3411 10.0854C61.3411 12.2883 62.887 13.8779 65.0973 13.8779C66.3352 13.8779 67.2943 13.5279 68.1142 12.7752L67.5569 12.0777C66.8737 12.6699 66.0512 12.9805 65.1697 12.9805C63.664 12.9805 62.5896 12.0067 62.4315 10.4986L62.4235 10.4275H68.4946C68.5053 10.3143 68.5107 10.1828 68.5107 10.0538C68.4946 7.8351 67.0612 6.28491 65.025 6.28491H65.0277ZM67.439 9.61163H62.4369L62.4476 9.53794C62.6539 8.09566 63.6318 7.20081 65.0036 7.20081C66.3753 7.20081 67.2756 8.11934 67.431 9.54057L67.439 9.61426V9.61163Z"
        fill="#F8FFF9"
      />
      <path
        d="M73.3333 6.2851C71.1042 6.2851 69.4886 7.88003 69.4886 10.0777C69.4886 12.2753 71.1042 13.8781 73.3333 13.8781C74.4184 13.8781 75.3802 13.486 76.0447 12.7754L75.3883 12.0674C74.7962 12.6122 74.0567 12.9096 73.3011 12.9096C71.7445 12.9096 70.5683 11.691 70.5683 10.075C70.5683 8.45905 71.7418 7.25101 73.3011 7.25101C74.0701 7.25101 74.764 7.53262 75.3668 8.08532L76.0447 7.38524C75.3856 6.67462 74.4264 6.28247 73.3333 6.28247V6.2851Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2166 7.62989C14.4893 7.62989 15.5208 6.61661 15.5208 5.36646C15.5208 4.11631 14.4866 3.10303 13.2166 3.10303C11.9467 3.10303 10.9125 4.11631 10.9125 5.36646C10.9125 6.61661 11.944 7.62989 13.2166 7.62989Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.57277 15.1413C5.80586 16.1493 6.72484 16.9021 7.82064 16.9021C9.09328 16.9021 10.1248 15.8888 10.1248 14.6386V14.6281C10.1248 13.8438 9.71218 13.0806 8.97271 12.6595C7.69204 11.933 6.93114 12.8726 5.65047 12.1462C5.29413 11.9436 5.06907 11.7146 4.90564 11.4751L5.57277 15.144V15.1413Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.723393 9.88006C0.377772 10.3064 0 10.6959 0 11.5355C0 12.7857 1.0315 13.799 2.30414 13.799C2.48097 13.799 2.65244 13.7805 2.81587 13.7437C3.35172 13.6647 3.87149 13.5516 4.58685 13.9569C5.20039 14.3043 5.40401 14.7201 5.57548 15.1412L4.90835 11.4724C4.72885 11.2065 4.619 10.9276 4.49039 10.6538C4.0644 9.7511 3.4053 9.62477 3.4053 8.45094C3.4053 7.83508 3.61428 7.44555 3.85809 7.09814L0.728751 9.88006H0.723393Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.8935 3.13204C2.53449 3.09519 2.17547 3.05571 1.76823 3.16362C0.752797 3.40049 -0.00274658 4.29534 -0.00274658 5.36652C-0.00274658 6.90354 1.26721 6.9246 1.26721 8.4511C1.26721 9.14329 1.00464 9.52491 0.720646 9.88022L3.84999 7.09831C4.79308 6.35085 4.39119 5.38231 5.6156 4.68749C6.24254 4.33218 6.71945 4.37429 7.18563 4.44272L2.89082 3.13204H2.8935Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1274 2.26343V2.20553V2.15026L10.1221 2.09762V2.04235L10.1167 2.03446L10.1114 1.98708L10.106 1.93971V1.92918C10.0471 1.54756 9.89166 1.19488 9.66393 0.900109L9.64517 0.876422L9.63446 0.863262C9.49781 0.692189 9.33438 0.542171 9.16023 0.421103L9.12004 0.392153L9.09325 0.373729L9.07718 0.363202C8.7262 0.142122 8.31627 0.0105276 7.8742 0H7.82329H7.81526H7.76167H7.75899H7.70541H7.65182L7.64914 0.00526379H7.63843L7.5902 0.0105276H7.58484C7.56609 0.0105276 7.55001 0.0157914 7.53126 0.0157914H7.52322L7.47767 0.0236871H7.45356L7.42141 0.0342147H7.41605L7.3705 0.0447422L7.32496 0.0552698H7.31424C7.04632 0.115803 6.79715 0.221079 6.57209 0.363202C6.42206 0.45795 6.29613 0.557962 6.19432 0.663238C5.93176 0.923796 5.73081 1.24489 5.62097 1.60283C5.41466 2.05551 5.20033 2.50557 4.55999 2.86877C3.91965 3.23197 3.40792 3.17933 2.89886 3.12669L7.19368 4.43738C7.39462 4.49265 7.60628 4.52423 7.82597 4.52423C7.92511 4.52423 8.02424 4.51897 8.12069 4.50581C8.3645 4.48212 8.62706 4.41106 8.9191 4.25315C8.95393 4.23472 8.99144 4.21367 9.02627 4.19261L9.03967 4.18472L9.07182 4.16366L9.10665 4.13997L9.11736 4.13471C9.38261 3.95837 9.6023 3.73466 9.76574 3.47937L9.77378 3.46884L9.79253 3.43726L9.81396 3.40041V3.39251C10.0176 3.05826 10.1301 2.67138 10.1301 2.25554"
        fill="#F8FFF9"
      />
    </g>
    <defs>
      <clipPath id="clip0_2065_3">
        <rect width="76.0473" height="16.8994" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const chemsecSvgLarge = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="296"
    height="66"
    viewBox="0 0 296 66"
    fill="none"
  >
    <g clipPath="url(#clip0_2118_333)">
      <path
        d="M87.849 34.0532L87.0668 33.3028C85.0646 31.3807 82.8433 30.4453 80.278 30.4453C75.2619 30.4453 71.6328 34.2485 71.6328 39.4804C71.6328 44.7123 75.2723 48.5565 80.278 48.5565C82.7703 48.5565 85.2106 47.5287 87.1607 45.6682L87.9637 44.8973L92.0829 49.3583L91.4364 50.0778C88.7458 53.0689 84.8247 54.7135 80.3927 54.7135C71.4868 54.7135 65.0316 48.3098 65.0316 39.4804C65.0316 30.6509 71.4972 24.2781 80.3927 24.2781C84.856 24.2781 88.7771 25.933 91.4364 28.9241L92.0829 29.6539"
        fill="#F8FFF9"
      />
      <path
        d="M110.406 24.2887C108.414 24.2887 105.056 24.6896 102.251 26.9714V10.6693H95.712V54.1691H102.251V37.7642C102.251 33.4882 105.275 30.5073 109.613 30.5073C113.951 30.5073 116.485 33.0462 116.485 37.6511V54.1691H123.003V36.2429C123.003 29.0889 117.935 24.2887 110.406 24.2887Z"
        fill="#F8FFF9"
      />
      <path
        d="M141.566 54.724C132.712 54.724 126.528 48.4745 126.528 39.5217C126.528 30.5689 132.743 24.2886 141.316 24.2886C149.398 24.2886 155.3 30.6409 155.363 39.3984C155.363 40.0151 155.331 40.6318 155.269 41.1355L155.154 42.0811H133.338C134.224 46.2646 137.394 48.8137 141.837 48.8137C144.799 48.8137 147.573 47.7242 149.846 45.6787L150.712 44.8975L154.372 49.4921L153.663 50.1602C150.378 53.2644 146.54 54.7137 141.576 54.7137L141.566 54.724ZM133.442 36.4689H148.584C147.75 32.6041 145.007 30.2503 141.222 30.2503C137.436 30.2503 134.422 32.5527 133.442 36.4689Z"
        fill="#F8FFF9"
      />
      <path
        d="M159.2 24.8333H165.686V27.0022C168.471 24.6894 171.871 24.2886 173.894 24.2886C178.367 24.2886 182.038 25.9949 184.259 29.0271C186.543 25.9949 190.225 24.2886 194.646 24.2886C202.196 24.2886 207.275 29.099 207.275 36.2428V54.169H200.757V37.651C200.757 33.0461 198.307 30.5072 193.854 30.5072C189.401 30.5072 186.491 33.4881 186.491 37.764V54.169H179.984V37.651C179.984 33.0461 177.544 30.5072 173.112 30.5072C168.679 30.5072 165.739 33.4881 165.739 37.764V54.169H159.2"
        fill="#F8FFF9"
      />
      <path
        d="M211.551 50.7152C214.502 52.7915 219.414 54.1689 223.867 54.1689C229.561 54.1689 236.214 51.8664 236.214 45.3599C236.214 39.9842 231.021 38.2882 226.651 37.8153L223.867 37.507C218.715 36.9416 216.421 35.5129 216.421 32.8815C216.452 29.8698 219.518 27.9271 224.242 27.9271C228.622 27.9271 231.97 29.5101 233.69 30.5482L235.474 27.6188C232.105 25.5836 228.424 24.5865 224.242 24.5865C217.213 24.5865 212.489 28.0711 212.489 33.2516C212.489 38.7404 217.568 40.4261 221.823 40.8784L224.67 41.1868C227.944 41.5362 232.293 42.3894 232.293 45.7608C232.293 48.9061 229.071 50.8591 223.877 50.8591C219.904 50.8591 215.879 49.3276 213.532 47.7652L211.551 50.7152Z"
        fill="#F8FFF9"
      />
      <path
        d="M253.108 24.5464C244.796 24.5464 238.758 30.7856 238.758 39.3889C238.758 47.9923 244.776 54.2007 253.379 54.2007C258.197 54.2007 261.93 52.8336 265.121 49.8938L262.952 47.17C260.293 49.4827 257.092 50.6956 253.661 50.6956C247.8 50.6956 243.618 46.8924 243.003 41.0027L242.972 40.7252H266.602C266.644 40.2832 266.665 39.7693 266.665 39.2656C266.602 30.6006 261.023 24.5464 253.097 24.5464H253.108ZM262.493 37.5388H243.024L243.065 37.251C243.868 31.6182 247.675 28.1234 253.014 28.1234C258.353 28.1234 261.857 31.7107 262.462 37.2612L262.493 37.549V37.5388Z"
        fill="#F8FFF9"
      />
      <path
        d="M285.436 24.5462C276.76 24.5462 270.471 30.7751 270.471 39.3579C270.471 47.9407 276.76 54.2004 285.436 54.2004C289.66 54.2004 293.403 52.6689 295.99 49.8936L293.435 47.1286C291.13 49.2563 288.252 50.4178 285.311 50.4178C279.252 50.4178 274.674 45.6588 274.674 39.3476C274.674 33.0364 279.242 28.3185 285.311 28.3185C288.304 28.3185 291.005 29.4183 293.351 31.5768L295.99 28.8427C293.424 26.0674 289.691 24.5359 285.436 24.5359V24.5462Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.4433 29.7977C56.3968 29.7977 60.4117 25.8403 60.4117 20.9579C60.4117 16.0755 56.3864 12.1182 51.4433 12.1182C46.5002 12.1182 42.4749 16.0755 42.4749 20.9579C42.4749 25.8403 46.4898 29.7977 51.4433 29.7977Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.691 59.134C22.5982 63.0708 26.1752 66.0105 30.4404 66.0105C35.3939 66.0105 39.4088 62.0532 39.4088 57.1708V57.1296C39.4088 54.0666 37.8029 51.0857 34.9246 49.4411C29.9398 46.6042 26.9782 50.2737 21.9934 47.4368C20.6064 46.6453 19.7304 45.751 19.0943 44.8157L21.691 59.1443V59.134Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.81567 38.5865C1.47041 40.2516 0 41.7729 0 45.0518C0 49.9342 4.01494 53.8916 8.96843 53.8916C9.65671 53.8916 10.3241 53.8196 10.9603 53.6757C13.0459 53.3673 15.0691 52.9254 17.8534 54.5083C20.2415 55.8651 21.0341 57.4891 21.7015 59.1337L19.1048 44.8051C18.4061 43.767 17.9786 42.6774 17.478 41.6084C15.8199 38.0828 13.2545 37.5894 13.2545 33.0051C13.2545 30.5999 14.0679 29.0786 15.0169 27.7218L2.83653 38.5865H2.81567Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2625 12.2319C9.86508 12.088 8.46768 11.9338 6.88256 12.3552C2.93019 13.2803 -0.0106201 16.7751 -0.0106201 20.9586C-0.0106201 26.9614 4.93245 27.0436 4.93245 33.0053C4.93245 35.7086 3.91046 37.199 2.80505 38.5867L14.9854 27.722C18.6562 24.8028 17.092 21.0203 21.8578 18.3067C24.298 16.919 26.1543 17.0835 27.9688 17.3507L11.2521 12.2319H11.2625Z"
        fill="#F8FFF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.4195 8.83975V8.61361V8.39776L39.3986 8.19218V7.97633L39.3778 7.94549L39.3569 7.76047L39.3361 7.57546V7.53434C39.1066 6.04392 38.5018 4.66656 37.6154 3.51534L37.5424 3.42283L37.5007 3.37144C36.9688 2.70332 36.3327 2.11743 35.6548 1.6446L35.4984 1.53154L35.3941 1.45959L35.3316 1.41847C33.9654 0.555054 32.3699 0.0411151 30.6492 0H30.4511H30.4198H30.2112H30.2008H29.9922H29.7836L29.7732 0.0205575H29.7315L29.5438 0.0411151H29.5229C29.4499 0.0411151 29.3874 0.0616726 29.3144 0.0616726H29.2831L29.1058 0.092509H29.0119L28.8868 0.133624H28.8659L28.6887 0.174739L28.5114 0.215854H28.4697C27.4268 0.452266 26.457 0.863417 25.581 1.41847C24.997 1.78851 24.5069 2.1791 24.1106 2.59025C23.0886 3.60785 22.3065 4.86186 21.8789 6.25977C21.0759 8.02772 20.2416 9.78539 17.7492 11.2039C15.2569 12.6223 13.265 12.4168 11.2836 12.2112L28.0004 17.33C28.7825 17.5459 29.6063 17.6692 30.4615 17.6692C30.8473 17.6692 31.2332 17.6487 31.6086 17.5973C32.5576 17.5048 33.5796 17.2272 34.7163 16.6105C34.8518 16.5385 34.9978 16.4563 35.1334 16.3741L35.1856 16.3432L35.3107 16.261L35.4463 16.1685L35.488 16.148C36.5204 15.4593 37.3755 14.5856 38.0117 13.5885L38.0429 13.5474L38.1159 13.4241L38.1994 13.2802V13.2493C38.9919 11.9439 39.4299 10.433 39.4299 8.80891"
        fill="#F8FFF9"
      />
    </g>
    <defs>
      <clipPath id="clip0_2118_333">
        <rect width="296" height="66" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle cx="7.2" cy="7.2" r="6.2" stroke="#757575" strokeWidth="2" />
    <line
      x1="11.5071"
      y1="11.2929"
      x2="18.7071"
      y2="18.4929"
      stroke="#757575"
      strokeWidth="2"
    />
  </svg>
);

const burgerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="36px"
    viewBox="0 -960 960 960"
    width="36px"
    fill="none"
  >
    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
  </svg>
);

const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="36px"
    viewBox="0 -960 960 960"
    width="36px"
    fill="#5f6368"
  >
    <path d="m251.33-204.67-46.66-46.66L433.33-480 204.67-708.67l46.66-46.66L480-526.67l228.67-228.66 46.66 46.66L526.67-480l228.66 228.67-46.66 46.66L480-433.33 251.33-204.67Z" />
  </svg>
);

const linkedInIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.60001 16H0.199997V5.3H3.60001V16ZM1.9 3.8C0.800002 3.8 0 3 0 1.9C0 0.8 0.900002 0 1.9 0C3 0 3.8 0.8 3.8 1.9C3.8 3 3 3.8 1.9 3.8ZM16 16H12.6V10.2C12.6 8.5 11.9 8 10.9 8C9.89999 8 8.89999 8.8 8.89999 10.3V16H5.5V5.3H8.7V6.8C9 6.1 10.2 5 11.9 5C13.8 5 15.8 6.1 15.8 9.4V16H16Z"
      fill="#0E0E0E"
    />
  </svg>
);

const blueskyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path 
      d="M3.8 2.5c1.6 1.2 3.3 3.6 3.9 4.9 0.6-1.3 2.3-3.7 3.9-4.9 1.15-0.86 3.0-1.52 3.0 0.59 0 0.42-0.24 3.55-0.38 4.05-0.5 1.77-2.3 2.22-3.9 1.95 2.8 0.48 3.5 2.05 1.97 3.63-2.92 3.0-4.2-0.75-4.53-1.71-0.06-0.18-0.09-0.26-0.09-0.19 0-0.07-0.03 0.01-0.09 0.19-0.33 0.96-1.6 4.71-4.53 1.71-1.54-1.58-0.82-3.15 1.97-3.63-1.6 0.27-3.4-0.18-3.9-1.95-0.14-0.5-0.38-3.63-0.38-4.05 0-2.11 1.85-1.45 3.0-0.59Z"
      fill="#0E0E0E"
    />
  </svg>
);


const youtubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      d="M15.6 2.09941C15.4 1.39941 14.9 0.899414 14.2 0.699414C13 0.399414 7.89999 0.399414 7.89999 0.399414C7.89999 0.399414 2.90001 0.399414 1.60001 0.699414C0.900006 0.899414 0.399997 1.39941 0.199997 2.09941C-3.05474e-06 3.39941 0 5.99941 0 5.99941C0 5.99941 3.03984e-06 8.59941 0.300003 9.89941C0.500003 10.5994 0.999997 11.0994 1.7 11.2994C2.9 11.5994 8 11.5994 8 11.5994C8 11.5994 13 11.5994 14.3 11.2994C15 11.0994 15.5 10.5994 15.7 9.89941C16 8.59941 16 5.99941 16 5.99941C16 5.99941 16 3.39941 15.6 2.09941ZM6.39999 8.39941V3.59941L10.6 5.99941L6.39999 8.39941Z"
      fill="#0E0E0E"
    />
  </svg>
);

const arrow_right = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM0 9H16V7H0V9Z"
      fill="#0E0E0E"
    />
  </svg>
);

const arrow_stroke = (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7216 1.63282L7.67216 7.71985C7.30094 8.09338 6.69906 8.09338 6.32784 7.71985L0.278418 1.63282C-0.092805 1.25929 -0.0928049 0.653678 0.278418 0.280147C0.64964 -0.0933832 1.25151 -0.0933832 1.62273 0.280147L6.44317 5.13055L7.55683 5.13055L12.3773 0.280148C12.7485 -0.0933827 13.3504 -0.0933827 13.7216 0.280148C14.0928 0.653679 14.0928 1.25929 13.7216 1.63282Z"
      fill="#0E0E0E"
    />
  </svg>
);

const infoIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_1810)">
      <path
        d="M8.5 16.5C12.9183 16.5 16.5 12.9183 16.5 8.5C16.5 4.08172 12.9183 0.5 8.5 0.5C4.08172 0.5 0.5 4.08172 0.5 8.5C0.5 12.9183 4.08172 16.5 8.5 16.5Z"
        fill="#0E0E0E"
      />
      <path
        d="M8.88938 6.18648C9.53132 6.18648 10.0517 5.66609 10.0517 5.02415C10.0517 4.38221 9.53132 3.86182 8.88938 3.86182C8.24745 3.86182 7.72705 4.38221 7.72705 5.02415C7.72705 5.66609 8.24745 6.18648 8.88938 6.18648Z"
        fill="white"
      />
      <path
        d="M10.3933 11.7944L10.389 11.7888C10.33 11.7101 10.219 11.696 10.1431 11.7593C9.98988 11.8844 9.72565 12.0544 9.4319 12.0685C9.02712 12.0882 8.77695 11.7438 8.87814 11.1999L9.57385 7.09869C9.60618 6.91176 9.46142 6.7417 9.27168 6.7417H6.62797C6.52677 6.7417 6.44385 6.82462 6.44385 6.92582C6.44385 7.00874 6.50007 7.08183 6.58018 7.10431L7.33914 7.30811C7.44877 7.33762 7.51904 7.44585 7.49936 7.55828L6.94701 10.8457C6.75868 11.9378 6.96528 12.9919 8.20773 13.131C9.26043 13.2491 9.99128 12.5576 10.3947 12.008C10.441 11.9448 10.441 11.8577 10.3947 11.7958L10.3933 11.7944Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_1810">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const star = (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z"
      fill="#0E0E0E"
    />
  </svg>
);

const bioBased = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.49958 0.311523C9.49958 0.311523 8.34937 1.37928 7.10488 1.80977C-2.10835 4.99806 1.77701 11.2112 1.90381 11.2317C1.90381 11.2317 2.42046 10.3707 3.11824 9.87995C7.54702 6.76531 8.44734 3.18 8.44734 3.18C8.44734 3.18 7.45357 7.49434 3.51345 10.1785C2.64317 10.7709 2.05407 12.2301 1.8046 13.6886C1.8046 13.6886 2.42128 13.4503 2.68681 13.3857C2.79014 12.7402 3.00668 12.1218 3.37225 11.5692C8.87878 12.1962 10.6823 7.95122 10.9178 6.47109C11.4735 2.9752 9.49958 0.311523 9.49958 0.311523Z"
      fill="#0E0E0E"
    />
  </svg>
);

const downloadFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="23"
    viewBox="0 0 16 23"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.32571 0.537444C5.66983 0.193325 6.13655 0 6.62321 0H13.4563C14.4697 0 15.2913 0.821535 15.2913 1.83495V17.7379C15.2913 18.7513 14.4697 19.5728 13.4563 19.5728H1.83495C0.821536 19.5728 0 18.7513 0 17.7379V6.62321C0 6.13655 0.193324 5.66983 0.537444 5.32571L5.32571 0.537444ZM6.62321 1.2233C6.46099 1.2233 6.30542 1.28774 6.19071 1.40245L1.40245 6.19071C1.28774 6.30542 1.2233 6.46099 1.2233 6.62321V17.7379C1.2233 18.0757 1.49715 18.3495 1.83495 18.3495H13.4563C13.7941 18.3495 14.068 18.0757 14.068 17.7379V1.83495C14.068 1.49715 13.7941 1.2233 13.4563 1.2233H6.62321Z"
      fill="white"
    />
    <path d="M8.56322 8.56279V2.44629L2.44672 8.56279H8.56322Z" fill="white" />
    <rect x="2" y="18" width="11.5" height="2" fill="#0C8848" />
    <path
      d="M8 21L8 13"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 17.4263L7.93586 21.4912L4.37173 17.4263"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const penIcon = (
  <svg
    width="22"
    height="42"
    viewBox="0 0 22 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_2935)">
      <path
        d="M9.84263 6.51855L0.466797 30.5879C2.31435 30.9339 4.22706 31.5373 5.693 32.1082C7.15894 32.679 8.97702 33.5291 10.5702 34.5235L19.9475 10.4479C18.7872 9.68623 17.2018 8.82683 15.0828 8.00156C12.9638 7.17629 11.2155 6.73728 9.84107 6.51855H9.84263ZM14.363 12.8803L8.46355 28.0268C8.24327 28.593 7.60571 28.8738 7.03949 28.652C6.47328 28.4317 6.19251 27.7941 6.41279 27.2279L12.3122 12.0814C12.5325 11.5152 13.1701 11.2344 13.7363 11.4562C14.3025 11.6765 14.5833 12.3141 14.363 12.8803Z"
        fill="#0F8437"
      />
      <path
        d="M0 32.7285L1.25342 40.3344C1.4194 41.3396 2.59992 41.7987 3.40037 41.1705L9.47201 36.4128C8.33959 35.7007 6.83331 34.9142 4.89578 34.1588C2.95826 33.4049 1.31857 32.9659 0.00155126 32.7285H0Z"
        fill="#0F8437"
      />
      <path
        d="M20.2812 2.16238L15.2039 0.184521C13.8155 -0.356869 12.2519 0.33034 11.7105 1.71872L10.6541 4.42877C12.5001 4.77471 14.4143 5.37815 15.8803 5.94901C17.3462 6.51988 19.1643 7.36997 20.7574 8.36433L21.8138 5.65427C22.3552 4.26589 21.668 2.70222 20.2796 2.16238H20.2812Z"
        fill="#0F8437"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_2935">
        <rect width="22" height="41.4559" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const documentIcon = (
  <svg
    width="28"
    height="36"
    viewBox="0 0 28 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_2932)">
      <rect
        width="27.33"
        height="34.7961"
        transform="translate(0.669922 0.399414)"
        fill="#0F8437"
      />
      <path
        d="M9.64697 1.271C9.41756 1.42982 9.20172 1.60086 9.00489 1.79905L2.06956 8.73302C1.87137 8.93122 1.70033 9.15113 1.5415 9.37511H9.64562V1.271H9.64697Z"
        fill="#FAFBEF"
      />
      <path
        d="M24.0415 0.399414H12.3795C12.1501 0.399414 11.9302 0.434708 11.7102 0.46593V10.4067C11.7102 10.9796 11.2474 11.4411 10.6759 11.4411H0.736438C0.705216 11.661 0.669922 11.8863 0.669922 12.1103V31.2385C0.669922 33.4227 2.44007 35.1955 4.62696 35.1955H24.0415C26.2298 35.1955 27.9986 33.4213 27.9986 31.2385V4.35645C27.9986 2.17227 26.2243 0.399414 24.0415 0.399414ZM20.956 29.9353H7.70978C7.13692 29.9353 6.67538 29.4724 6.67538 28.9009C6.67538 28.3294 7.13828 27.8665 7.70978 27.8665H20.956C21.5289 27.8665 21.9904 28.3294 21.9904 28.9009C21.9904 29.4724 21.5275 29.9353 20.956 29.9353ZM20.956 24.1063H7.70978C7.13692 24.1063 6.67538 23.6434 6.67538 23.0719C6.67538 22.5004 7.13828 22.0375 7.70978 22.0375H20.956C21.5289 22.0375 21.9904 22.5004 21.9904 23.0719C21.9904 23.6434 21.5275 24.1063 20.956 24.1063ZM20.956 18.2733H7.70978C7.13692 18.2733 6.67538 17.8104 6.67538 17.2389C6.67538 16.6674 7.13828 16.2045 7.70978 16.2045H20.956C21.5289 16.2045 21.9904 16.6674 21.9904 17.2389C21.9904 17.8104 21.5275 18.2733 20.956 18.2733Z"
        fill="#FAFBEF"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_2932">
        <rect
          width="27.33"
          height="34.7961"
          fill="white"
          transform="translate(0.669922 0.399414)"
        />
      </clipPath>
    </defs>
  </svg>
);

const eyeIcon = (
  <svg
    width="38"
    height="24"
    viewBox="0 0 38 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_2939)">
      <path
        d="M23.5704 11.8551C23.5704 14.5684 21.3657 16.7752 18.655 16.7752C15.9443 16.7752 13.739 14.5681 13.739 11.8551C13.739 9.14211 15.9443 6.93506 18.655 6.93506C21.3657 6.93506 23.5704 9.14183 23.5704 11.8551Z"
        fill="#0F8437"
      />
      <path
        d="M37.7725 11.1278C33.0822 4.41559 26.2395 0.56543 19.0002 0.56543C11.761 0.56543 4.91878 4.41559 0.227425 11.1278C-0.0761338 11.5618 -0.0761338 12.1485 0.227425 12.5825C4.91851 19.2947 11.7602 23.1449 19.0002 23.1449C26.2403 23.1449 33.0822 19.2947 37.7725 12.5825C38.0758 12.1485 38.0758 11.5618 37.7725 11.1278ZM18.6549 20.2672C14.0203 20.2672 10.2503 16.4939 10.2503 11.855C10.2503 7.21611 14.0203 3.44334 18.6549 3.44334C23.2894 3.44334 27.0589 7.21666 27.0589 11.8553C27.0589 16.4939 23.2889 20.2675 18.6549 20.2675V20.2672Z"
        fill="#0F8437"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_2939">
        <rect
          width="38"
          height="22.5797"
          fill="white"
          transform="translate(0 0.56543)"
        />
      </clipPath>
    </defs>
  </svg>
);

const chooseFileIcon = (
  <svg
    width="53"
    height="38"
    viewBox="0 0 53 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_2890)">
      <path
        d="M20.0642 25.6817L26.5302 18.3071L32.9962 25.6817"
        stroke="#0F8437"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5305 19.0498V35.5252"
        stroke="#0F8437"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7015 31.4214H10.8272C4.77002 31.4214 1.92316 27.6659 1.92316 23.8499C1.91832 22.7155 2.17689 21.5954 2.67851 20.5779C3.18013 19.5604 3.91111 18.6732 4.81389 17.9862C5.71667 17.2992 6.76661 16.8312 7.88103 16.6189C8.99544 16.4067 10.1439 16.456 11.236 16.7631C8.31345 11.2057 10.6 6.51137 14.8249 4.3308C16.0655 3.63332 17.4513 3.23397 18.8729 3.16432C20.2944 3.09466 21.7127 3.35661 23.0155 3.92946C24.3184 4.50231 25.4701 5.37035 26.3798 6.46498C27.2894 7.5596 27.9319 8.8508 28.2566 10.2365C29.0803 8.74414 30.4268 7.60916 32.0371 7.05003C33.6474 6.49091 35.4076 6.54715 36.9789 7.20794C37.7929 7.54717 38.5248 8.05672 39.1255 8.70236C39.7262 9.34799 40.1818 10.1147 40.4615 10.9511C40.7412 11.7874 40.8387 12.6739 40.7473 13.551C40.6559 14.4281 40.3778 15.2755 39.9317 16.0362C46.6249 14.2191 51.0769 17.7777 51.0769 23.8499C51.0769 28.1354 47.6546 31.4214 41.5974 31.4214H34.3289"
        stroke="#0F8437"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_2890">
        <rect width="53" height="37.8571" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const chooseDocumentIcon = (
  <svg
    width="35"
    height="51"
    viewBox="0 0 35 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1015 1.22122C12.8834 0.439287 13.9439 0 15.0498 0H30.5765C32.8792 0 34.746 1.86676 34.746 4.16952V40.3053C34.746 42.6081 32.8792 44.4749 30.5765 44.4749H4.16952C1.86676 44.4749 0 42.6081 0 40.3053V15.0498C0 13.9439 0.439286 12.8834 1.22122 12.1015L12.1015 1.22122ZM15.0498 2.77968C14.6812 2.77968 14.3277 2.92611 14.067 3.18675L3.18675 14.067C2.92611 14.3277 2.77968 14.6812 2.77968 15.0498V40.3053C2.77968 41.0729 3.40193 41.6952 4.16952 41.6952H30.5765C31.344 41.6952 31.9663 41.0729 31.9663 40.3053V4.16952C31.9663 3.40193 31.344 2.77968 30.5765 2.77968H15.0498Z"
      fill="#0F8437"
    />
    <path d="M19.458 19.457V5.55859L5.55957 19.457H19.458Z" fill="#0F8437" />
    <rect
      x="8.68652"
      y="39.958"
      width="19.9789"
      height="6.08055"
      fill="#F8FFF9"
    />
    <path
      d="M18.6465 34.5225V48.8338"
      stroke="#0F8437"
      strokeWidth="3.06484"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0298 40.2829L18.6465 33.877L24.2632 40.2829"
      stroke="#0F8437"
      strokeWidth="3.06484"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const checkIcon = (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.11559L4.3846 8.50021L11.8846 1"
      stroke="#0E0E0E"
      strokeWidth="2"
    />
  </svg>
);

const profileIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_6449)">
      <path
        d="M15.3001 15.4599C15.3114 13.9402 14.8133 12.4604 13.8853 11.2569C12.9572 10.0533 11.6528 9.19538 10.1801 8.81994C10.9764 8.43109 11.6175 7.78387 11.9988 6.98385C12.38 6.18383 12.4789 5.27823 12.2794 4.41477C12.0798 3.55131 11.5936 2.78095 10.9 2.22934C10.2064 1.67774 9.34628 1.37744 8.46006 1.37744C7.57384 1.37744 6.71377 1.67774 6.02015 2.22934C5.32653 2.78095 4.84028 3.55131 4.64073 4.41477C4.44118 5.27823 4.5401 6.18383 4.92136 6.98385C5.30262 7.78387 5.94371 8.43109 6.74006 8.81994C5.26737 9.19538 3.96289 10.0533 3.03486 11.2569C2.10682 12.4604 1.60872 13.9402 1.62006 15.4599H11.5401"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_6449">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const signOutIcon = (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2121_1945)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.90625C0 1.57731 1.07731 0.5 2.40625 0.5H9.84375C10.2062 0.5 10.5 0.793813 10.5 1.15625C10.5 1.51869 10.2062 1.8125 9.84375 1.8125H2.40625C1.80219 1.8125 1.3125 2.30219 1.3125 2.90625V12.0938C1.3125 12.6978 1.80218 13.1875 2.40625 13.1875H9.84375C10.2062 13.1875 10.5 13.4813 10.5 13.8438C10.5 14.2062 10.2062 14.5 9.84375 14.5H2.40625C1.07732 14.5 0 13.4227 0 12.0938V2.90625ZM9.80035 4.2097C10.047 3.94411 10.4622 3.92873 10.7278 4.17535L13.7903 7.0191C13.924 7.14327 14 7.31752 14 7.5C14 7.68248 13.924 7.85672 13.7903 7.9809L10.7278 10.8246C10.4622 11.0713 10.047 11.0559 9.80035 10.7903C9.55373 10.5247 9.56911 10.1095 9.8347 9.86285L11.6726 8.15625H5.90625C5.54381 8.15625 5.25 7.86244 5.25 7.5C5.25 7.13756 5.54381 6.84375 5.90625 6.84375H11.6726L9.8347 5.13715C9.56911 4.89053 9.55373 4.4753 9.80035 4.2097Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2121_1945">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export {
  marketplaceSvg,
  chemsecSvg,
  chemsecSvgLarge,
  searchIcon,
  burgerIcon,
  linkedInIcon,
  blueskyIcon,
  youtubeIcon,
  arrow_right,
  closeIcon,
  arrow_stroke,
  infoIcon,
  star,
  bioBased,
  downloadFileIcon,
  penIcon,
  documentIcon,
  eyeIcon,
  chooseFileIcon,
  chooseDocumentIcon,
  checkIcon,
  profileIcon,
  signOutIcon,
};
